// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.copy-summary-collapses[data-v-1754deb1] {
  width: 100%;
  text-align: left;
}
.summary-header[data-v-1754deb1] {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 5px;
}
.info-icon[data-v-1754deb1] {
  color: #6c9ec4;
  font-size: 1.1rem;
}
.summary-title[data-v-1754deb1] {
  font-weight: 600;
  color: #333;
}
.summary-description[data-v-1754deb1] {
  color: #666;
  font-size: 0.9rem;
  margin-bottom: 20px;
  margin-left: 26px;
}
.collapsible-sections[data-v-1754deb1] {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}
.detail-item-header[data-v-1754deb1] {
  display: flex;
  align-items: center;
  gap: 8px;
}
.item-icon[data-v-1754deb1] {
  font-size: 0.95rem;
}
.item-icon.success[data-v-1754deb1] {
  color: #28a745;
}
.item-icon.info[data-v-1754deb1] {
  color: #17a2b8;
}
.item-icon.danger[data-v-1754deb1] {
  color: #dc3545;
}
.item-name[data-v-1754deb1] {
  font-weight: 600;
  color: #333;
}
.detail-item-subtitle[data-v-1754deb1] {
  color: #666;
  font-size: 0.85rem;
  margin-left: 23px;
  margin-top: 2px;
}
.detail-item-info[data-v-1754deb1] {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-left: 23px;
  margin-top: 4px;
}
.info-text[data-v-1754deb1] {
  color: #17a2b8;
  font-size: 0.85rem;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
